import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faInfoCircle } from '@fortawesome/pro-solid-svg-icons/faInfoCircle';

import React, { useState } from 'react';
import PropTypes from 'prop-types';
import ModalPortal from '../../components/modal-portal';
import ShipperHQModal from '../shipperhq-details-modal';
import style from './style.module.less';

export const ShipperHQDetailsButton = ({ storeGuid, orderNumber }) => {
  const [isShipperHQDetailsModalOpen, setIsShipperHQDetailsModalOpen] = useState(false);

  const openShipperHQModal = () => setIsShipperHQDetailsModalOpen(true);
  const closeShipperHQModal = () => setIsShipperHQDetailsModalOpen(false);

  return (
    <>
      <button className={style['target-icon']} onClick={openShipperHQModal}>
        <FontAwesomeIcon icon={faInfoCircle} />
      </button>
      {isShipperHQDetailsModalOpen && (
        <ModalPortal onClose={closeShipperHQModal}>
          <ShipperHQModal onClose={closeShipperHQModal} orderNumber={orderNumber} storeGuid={storeGuid} />
        </ModalPortal>
      )}
    </>
  );
};

ShipperHQDetailsButton.propTypes = {
  storeGuid: PropTypes.string.isRequired,
  orderNumber: PropTypes.string.isRequired,
};
